import { useMemo } from "react";
import SaleryInfoField from "./Components/SalaryInfofield/SalaryInfofield.js";
import styles from "./Style.module.css";
import { getSumValue } from "../../../../src/libs/general.utils.js";
import { InfoOutlined } from "@material-ui/icons";
import { ButtonBase } from "@material-ui/core";
import moment from "moment";
import SalaryCalculatorDetailHook from "./SalaryCalculatorDetail.hook.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import history from "../../../libs/history.utils";

function SalaryInfoDetail({ Empid, isPending }) {
  const { EmployeeSalaryInfo: data } = SalaryCalculatorDetailHook({
    Empid,
    isPending,
  });

  const location = useLocation();
  const PreviewData = location?.state?.PreviewData || null;

  const isBeforeApril2025 = useMemo(() => {
    if (!data?.effective_date) return false;

    const targetDate = moment("2025-04-01");
    const currentDate = moment(data?.effective_date);

    return currentDate.isBefore(targetDate, "day");
  }, [data?.effective_date]);


  const isDateAfterApril2024 = useMemo(() => {
    return true;
    // if (!data?.effective_date) return false; // Return false if date is not present
    // const comparisonDate = moment("2024-04-01");
    // const givenDate = moment(data?.effective_date);
    // return givenDate?.isAfter(comparisonDate);
  }, []);

  return (
    <div id="content-to-print" className={styles.salaryInfoWrapper}>
      <div className={styles.informationIcon}>
        <InfoOutlined fontSize={"small"} style={{ color: "#2896E9" }} />
      </div>

      <div className={styles.pageWrap}>
        <div className={styles.wrappedValue}>
          <div>
            <ButtonBase onClick={() => history.goBack()}>
              <ArrowBackIosIcon fontSize={"small"} />{" "}
            </ButtonBase>
            <b>Salary Structure Preview</b>
            <div className={styles.newLine} />
          </div>
        </div>
      </div>
      <div className={styles.headerWrap}>
        <div className={styles.upperWrap}>
          <div className={styles.wrpa}>
            <div className={styles.titleHead}>Location:</div>
            <div className={styles.titleCont}>
              {PreviewData?.location_id?.name}
            </div>
          </div>
          <div className={styles.wrpa}>
            <div className={styles.titleHead}>Designation:</div>
            <div className={styles.titleCont}>
              {PreviewData?.designation_id?.name}
            </div>
          </div>
        </div>
        <div className={styles.upperWrap}>
          <div className={styles.wrpa}>
            <div className={styles.titleHead}>Grade:</div>
            <div className={styles.titleCont}>
              {PreviewData?.grade_id?.code}
            </div>
          </div>
          <div className={styles.wrpa}>
            <div className={styles.titleHead}>Cadre:</div>
            <div className={styles.titleCont}>
              {PreviewData?.cadre_id?.code}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.salaryTableContainer}>
        <div className={styles.tableWrapper}>
          <div className={styles.tableComponentField}>Component</div>
          <div className={styles.salaryWrapper2}>
            <div className={styles.tableAnnualField}>Annual</div>
            <div className={styles.tableMonthlyField}>Monthly</div>
          </div>
        </div>
        <div className={styles.grossWrapper}>
          <SaleryInfoField
            component="Incremental Gross Salary"
            monthly={PreviewData?.incremental_gross_salary}
          />
          <SaleryInfoField
            component="Car Component"
            monthly={PreviewData?.car_component}
          />
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            component="Total"
            monthly={getSumValue(
              PreviewData?.incremental_gross_salary,
              PreviewData?.car_component
            )}
          />
        </div>
        <div className={styles.grossWrapper}>
          <div>
            <p className={styles.salaryHeading}>Part A - Earning 1</p>
          </div>
          <SaleryInfoField component="Basic" monthly={PreviewData?.basic_salary} />
          <SaleryInfoField component="HRA" monthly={PreviewData?.hra} />
          <SaleryInfoField
            component="Education Allowance"
            monthly={PreviewData?.education_allowance}
          />
          <SaleryInfoField
            component="Special Allowance"
            monthly={PreviewData?.special_allowance}
          />
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            component="Total Earning 1"
            monthly={PreviewData?.earning_one}
          />
        </div>
        <div className={styles.grossWrapper}>
          <div>
            <p className={styles.salaryHeading}>Part B - Earning 2 </p>
          </div>
          <SaleryInfoField
            component="Professional Upgradation - Qtrly"
            monthly={PreviewData?.pug}
          />
          <SaleryInfoField
            component="Helper Allowance - Qtrly"
            monthly={PreviewData?.helper}
          />{" "}
          <SaleryInfoField
            component="Food Coupons  - Fringe"
            monthly={PreviewData?.food_coupons}
          />
          <SaleryInfoField
            component="Gift Coupons - Fringe"
            monthly={PreviewData?.gift_coupons}
          />{" "}
          <SaleryInfoField component="LTA - Bimonthly" monthly={PreviewData?.lta} />
          <SaleryInfoField
            component="Superannuation - Post Retire"
            monthly={PreviewData?.super_annuation}
          />{" "}
          <SaleryInfoField component="NPS" monthly={PreviewData?.nps} />
          <SaleryInfoField
            component="Vehicle Maint (CTC) - Fringe"
            monthly={PreviewData?.vehicle_maintenance}
          />{" "}
          <SaleryInfoField
            component="Vehicle EMIs (CTC) - Monthly"
            monthly={PreviewData?.vehicle_emi}
          />
          <SaleryInfoField
            component="Fuel Availed (CTC) - Fringe"
            monthly={PreviewData?.fuel}
          />{" "}
          <SaleryInfoField
            component="VPF - Monthly"
            monthly={PreviewData?.earning2_vpf}
          />
          {isDateAfterApril2024 && (
            <>
              <SaleryInfoField
                component="Driver Salary"
                monthly={PreviewData?.driver_salary}
              />{" "}
              <SaleryInfoField
                component="Uniform Allowance"
                monthly={PreviewData?.uniform_allowance}
              />{" "}
              <SaleryInfoField
                component="Telecom Allowance"
                monthly={PreviewData?.telecom_allowance}
              />{" "}
              <SaleryInfoField
                component="GTI"
                monthly={PreviewData?.gti}
              />{" "}
              <SaleryInfoField
                component="GMC"
                monthly={PreviewData?.gmc}
              />{" "}
              <SaleryInfoField
                component="Stat Bonus"
                monthly={PreviewData?.stat_bonus}
              />
            </>
          )}
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            component="Total Earning 2"
            monthly={PreviewData?.earning_two}
          />
        </div>{" "}
        <div className={styles.grossWrapper}>
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            id={styles.salaryInfoId}
            component=<span>Gross Salary <br />(Part A + Part B)</span>
            monthly={getSumValue(PreviewData?.earning_one, PreviewData?.earning_two)}
          />
        </div>{" "}
        <div className={styles.grossWrapper}>
          <div>
            <p className={styles.salaryHeading}>Part C - Earning 3</p>
          </div>
          <SaleryInfoField
            component="PLI - Qtrly"
            monthly={PreviewData?.earning_three_pli}
          />
        </div>
        <div className={styles.grossWrapper}>
          <div>
            <p className={styles.salaryHeading}>Part D - Deduction 1</p>
          </div>
          <SaleryInfoField
            component="Em PF- Deduction Part (Put Yes if give actual Basic's 12 %)"
            monthly={PreviewData?.em_pf}
          />
          <SaleryInfoField
            component="Em ESI- Deduction Part"
            monthly={PreviewData?.em_esi}
          />
          <SaleryInfoField component={`VPF - ${PreviewData?.deduction_vpf_pct} %`} monthly={PreviewData?.deduction_vpf} />
          <SaleryInfoField component="Em LWF" monthly={PreviewData?.em_lwf} />
          <SaleryInfoField
            className={styles.grossSalaryRedWrapper}
            component="Total Deduction 1"
            monthly={PreviewData?.total_deduction}
          />
        </div>{" "}
        <div className={styles.grossWrapper}>
          <div>
            <p className={styles.salaryHeading}>
              Part E (Statutory Components of CTC Paid by Employer) - Earning 4
            </p>
          </div>
          <SaleryInfoField
            component="PF - Er Contribution Part"
            monthly={PreviewData?.er_pf}
          />
          <SaleryInfoField
            component="ESI - Er Contribution Part"
            monthly={PreviewData?.er_esi}
          />
          <SaleryInfoField component="Er LWF" monthly={PreviewData?.er_lwf} />
          {/* {isDateAfterApril2024 && (
            <SaleryInfoField component="Gratuity" monthly={PreviewData?.gratuity} />
          )} */}
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            component="Total Earning 4"
            monthly={PreviewData?.earning_four}
          />
        </div>
        <div className={styles.grossWrapper}>
          <div>
            <p className={styles.salaryHeading}>
              Part E (Organizational Components of CTC) - Earning 5
            </p>
          </div>
          {
            isDateAfterApril2024 && <>
              <SaleryInfoField component="Gratuity" monthly={PreviewData?.gratuity} />
              {/* <SaleryInfoField
              component="Medical Insurance Premium"
              monthly={PreviewData?.insurance}
            />{" "} */}
            </>
          }
          <SaleryInfoField
            component="Stability Allowance"
            monthly={PreviewData?.stability_incentive}
          />{" "}
          <SaleryInfoField
            component="Retention Allowance"
            monthly={PreviewData?.retention_allowance}
          />
          <SaleryInfoField
            component="Performance Allowance"
            monthly={PreviewData?.perf_bonus}
          />{" "}
          {
            isDateAfterApril2024 &&
            <SaleryInfoField component="Bonus" monthly={PreviewData?.annual_bonus} />
          }
          <SaleryInfoField
            component="Type II Car Maint"
            monthly={PreviewData?.two_car_maintenance}
          />
          <SaleryInfoField component="Type II Fuel" monthly={PreviewData?.two_fuel} />
          <SaleryInfoField component="Deputation/City Allowance" monthly={PreviewData?.deputation_allowance} />
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            component="Total Earning 5"
            monthly={PreviewData?.earning_five}
          />
        </div>
        <div className={styles.grossWrapperBg}>
          <SaleryInfoField
            className={styles.grossSalaryGreenWrapper}
            component="Net Composite CTC (Earning 1 + Earning 2 + Earning 3 + Earning 4 + Earning 5)"
            monthly={getSumValue(PreviewData?.monthly_ctc)}
          />
        </div>{" "}
        <div className={styles.grossWrapper}>
          <SaleryInfoField
            component="Net Pay [ (Earning 1) - (Deduction 1) ]"
            monthly={PreviewData?.net_pay}
          />
        </div>
      </div>
    </div>
  );
}

export default SalaryInfoDetail;
